
type InputType = {
    type: string,
    value: string,
    placeholder: string,
    onChange: (value: string) => void,
    isInvalid?: boolean
    textInvalid?: string,
    isFullWidth?: boolean
}

const Input = ({type, value, placeholder, onChange, isInvalid = false, textInvalid = '', isFullWidth = false}: InputType) => {
    return <label className={`block ${isFullWidth ? ' w-full' : ''}`}>
        <input
            className={`form-input w-full rounded-lg border border-${isInvalid ? 'error bg-error' : 'slate-300'} bg-transparent px-3 py-2 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent`}
            placeholder={placeholder}
            type={type}
            value={value}
            onChange={(evt) => onChange(evt.target.value)}
        />
        { isInvalid && <span className="text-tiny+ text-error">{textInvalid}</span> }
    </label>
}

export default Input;
